import { render, staticRenderFns } from "./team-form-dialog.vue?vue&type=template&id=bb50073e&scoped=true"
import script from "./team-form-dialog.vue?vue&type=script&lang=js"
export * from "./team-form-dialog.vue?vue&type=script&lang=js"
import style0 from "./team-form-dialog.vue?vue&type=style&index=0&id=bb50073e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb50073e",
  null
  
)

export default component.exports